var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item[_vm.keyValue]),expression:"item[keyValue]"}],staticClass:"edit-line ml-2 mr-3",attrs:{"type":"text"},domProps:{"value":(_vm.item[_vm.keyValue])},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.item, _vm.keyValue, $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }